/**
 * App Theme Configuration
 *
 * Edit this file to change colors, font, and border radius.
 * The ThemeProvider applies these values as CSS variables on startup.
 *
 * Colors use HSL format: "hue saturation% lightness%"
 *
 * For preset inspiration, see src/lib/themes.ts — copy any preset's
 * values here and customize as needed.
 */

// ── Font presets (uncomment one, or add your own Google Fonts URL) ──
// Geometric sans — tech, clean, modern
// const font = { url: 'https://fonts.googleapis.com/css2?family=Inter:wght@400..700&display=swap', family: "'Inter', sans-serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400..700&display=swap', family: "'Space Grotesk', sans-serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Sora:wght@400..700&display=swap', family: "'Sora', sans-serif" };
// Humanist sans — friendly, approachable
// const font = { url: 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400..700&display=swap', family: "'DM Sans', sans-serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400..700&display=swap', family: "'Plus Jakarta Sans', sans-serif" };
// Serif — luxury, editorial, premium
// const font = { url: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400..900&display=swap', family: "'Playfair Display', serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400..700&display=swap', family: "'Cormorant Garamond', serif" };
// Mono — developer, hacker, terminal
// const font = { url: 'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400..700&display=swap', family: "'JetBrains Mono', monospace" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&display=swap', family: "'Space Mono', monospace" };
// Display — bold, creative, expressive
// const font = { url: 'https://fonts.googleapis.com/css2?family=Unbounded:wght@400..700&display=swap', family: "'Unbounded', sans-serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Syne:wght@400..700&display=swap', family: "'Syne', sans-serif" };

// TrashLink — Nigeria's plastic recovery network.
// Body copy runs on Inter (readable, generous line-height on dark surfaces).
// Headings run on Space Grotesk, loaded separately in index.html and wired
// through the `font-heading` Tailwind utility (see tailwind.config.ts).
const font = { url: 'https://fonts.googleapis.com/css2?family=Inter:wght@400..700&display=swap', family: "'Inter', sans-serif" };

// TrashLink design system — near-black charcoal base, Solana green -> purple
// gradient as the sparing accent, warm amber reserved exclusively for the
// future "Smart Scan" AI feature (see the extra `amber` token below).
export const theme = {
  colors: {
    background: '165 20% 5%',
    foreground: '60 20% 95%',
    card: '165 18% 16%',
    'card-foreground': '60 20% 95%',
    popover: '165 18% 10%',
    'popover-foreground': '60 20% 95%',
    primary: '153 90% 51%',
    'primary-foreground': '165 25% 6%',
    secondary: '165 16% 20%',
    'secondary-foreground': '60 10% 88%',
    muted: '165 12% 12%',
    'muted-foreground': '144 3% 58%',
    accent: '266 91% 65%',
    'accent-foreground': '0 0% 100%',
    destructive: '0 72% 51%',
    'destructive-foreground': '0 0% 100%',
    border: '165 15% 26%',
    input: '165 15% 26%',
    ring: '153 90% 51%',
    link: '153 70% 60%',
    'link-hover': '153 90% 68%',
    button: '165 14% 13%',
    'button-foreground': '60 20% 95%',
    'button-border': '165 15% 22%',
    'button-hover': '165 14% 18%',
    'button-hover-foreground': '60 20% 98%',
    'button-hover-border': '153 60% 42%',
    'button-ring': '153 90% 51%',
    'chart-1': '153 90% 51%',
    'chart-2': '266 91% 65%',
    'chart-3': '39 100% 56%',
    'chart-4': '190 70% 55%',
    'chart-5': '330 70% 60%',
    'sidebar-background': '165 22% 4%',
    'sidebar-foreground': '60 10% 85%',
    'sidebar-primary': '153 90% 51%',
    'sidebar-primary-foreground': '165 25% 6%',
    'sidebar-accent': '165 14% 10%',
    'sidebar-accent-foreground': '60 10% 85%',
    'sidebar-border': '165 15% 14%',
    'sidebar-ring': '153 90% 51%',
    // Extra token (not part of the base shadcn set) — reserved ONLY for the
    // future AI "Smart Scan" feature so it reads as "the smart/special part".
    // Applied automatically as --amber by the ThemeProvider. Use sparingly:
    // hsl(var(--amber)) or arbitrary Tailwind value [hsl(var(--amber))].
    amber: '39 100% 56%',
  },
  font,
  radius: '1rem',
};
